import { newsletterComponent } from "./newsletter.component";
import { SettingsService } from "../../settings.service";

export const newsletter = angular
  .module("components.newsletter", [])
  .component("newsletter", newsletterComponent)
  .service("SettingsService", SettingsService)
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state("newsletter", {
      parent: "app",
      url: "/newsletter",
      breadcrumbName: "newsletter",
      parentState: "settings",
      component: "newsletter",
    });
  }).name;



// WEBPACK FOOTER //
// ./src/app/components/settings/components/newsletter/newsletter.module.js